import React from 'react';

import { Box, ColumnsV2, ColumnsV2Props } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { isInIframe } from '@shared/utils/isInIframe';
import { StyledBoxBrannan } from './Frames.styles';
import { FrameOuterProps } from './Frames.types';
import { CustomArt } from '../CustomArt/CustomArt';

export const BrannanFrameMaxWidth = 1024;

const FrameOuter: React.FC<FrameOuterProps> = ({
  applicatorProp,
  children,
  loading,
  customBackgroundColor,
  loadingBackgroundColor,
  customTextColor,
  isCustomPage,
  isCustomArtEnabled,
  customArtUrl,
  ...restProps
}) => {
  const isPreviewing = isInIframe();
  return (
    <StyledBoxBrannan
      loading={loading}
      {...applicatorProp}
      transition={animationTransition('background', 'background-color')}
      data-testid={'outer-frame'}
      {...restProps}
      position={'relative'}
      isPreviewing={isPreviewing}
      customBackgroundColor={customBackgroundColor}
      loadingBackgroundColor={loadingBackgroundColor}
      customTextColor={customTextColor}
    >
      {isCustomArtEnabled && <CustomArt backgroundImageUrl={customArtUrl} />}
      {/* This overflow clip is necessary to prevent the center part of the page from scrolling */}
      <Box overflow={'clip'}>{children}</Box>
    </StyledBoxBrannan>
  );
};

const FrameInner: React.FC<HtmlProps<HTMLElement> & ColumnsV2Props> = ({ children, ...restProps }) => {
  return (
    <ColumnsV2
      fluid={true}
      maxWidth={[null, null, BrannanFrameMaxWidth]}
      {...restProps}
    >
      <ColumnsV2.Column data-testid={'inner-frame'}>{children}</ColumnsV2.Column>
    </ColumnsV2>
  );
};

export { FrameOuter, FrameInner };
